import { useTranslations } from 'next-intl';
import React from 'react';
import { LocationPopoverState } from '../lib/location-popover-state';

type Props = {
  state: LocationPopoverState;
};

const LocationTriggerLabel: React.FC<Props> = ({ state }) => {
  const t = useTranslations();

  if (state.triggerLabelKey === 'pending') {
    return <>{t('location.determining_location')}</>;
  }

  if (state.triggerLabelKey === 'enter_address') {
    return <>{t('enter_address')}</>;
  }

  if (state.triggerLabelKey === 'select_branch') {
    return <>{t('select_branch')}</>;
  }

  // ✅ address/branch display
  return <>{state.triggerLabelValue || t('enter_address')}</>;
};

export default LocationTriggerLabel;
